import script from "./ContactUs.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContactUs.vue?vue&type=script&setup=true&lang=ts"

import "./ContactUs.vue?vue&type=style&index=0&id=e5261012&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e5261012"]])

export default __exports__